import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Title, Wrapper, JobPositionCardCarousel } from '../../';
import { useTranslation } from 'next-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JobSimilarPositions = function JobSimilarPositions(props) {
  var _useTranslation = useTranslation('job-position-page'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Wrapper, {
    id: "similar-jobs-el",
    children: [/*#__PURE__*/_jsx(Title, {
      icon: "BriefcaseIcon",
      content: t('similar_positions'),
      variant: "h4-large",
      fontWeight: "semibold",
      textColor: "black"
    }, "main-title"), /*#__PURE__*/_jsx(JobPositionCardCarousel, _objectSpread({}, props))]
  });
};
export default JobSimilarPositions;